import { createSelector } from '@ngrx/store';

import { getMenuFlow } from '../getMenuFlow';

export const getMenuFlowDetails = (menuFlowId: number, locationNo: number) => createSelector(getMenuFlow(menuFlowId, locationNo), (menuFlow) => menuFlow?.data || null);
